/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterIncidentManagementConfiguration {
    getFixupPrototypeFunction() { return JiraDataCenterIncidentManagementConfiguration.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterIncidentManagementConfiguration>): JiraDataCenterIncidentManagementConfiguration {
        let obj = Object.assign(new JiraDataCenterIncidentManagementConfiguration(), model);
        JiraDataCenterIncidentManagementConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterIncidentManagementConfiguration>): JiraDataCenterIncidentManagementConfiguration {
        if (!model) return null;
        return JiraDataCenterIncidentManagementConfiguration.newInstance(<JiraDataCenterIncidentManagementConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterIncidentManagementConfiguration) {
        if (!obj) return;

        models.JiraDataCenterIncidentManagementConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterIncidentManagementConfiguration): boolean {
        Object.setPrototypeOf(obj, JiraDataCenterIncidentManagementConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.project) {
            models.JiraProject.fixupPrototype(this.project);
        }
    }

    project: models.JiraProject;

    /**
     * Summary of the Incident
     */
    summary: string;

    selected_description_attributes: Array<models.JiraServiceDeskIncidentDescriptionAttribute>;

    /**
     * Assignee of the Incident
     */
    assignee: string;

}
